import type React from "react";
import { Headline1, useMedia, XStack, YStack } from "@medbillai/ui";
export type PageHeaderProps = {
  title: string;
  actions?: React.ReactNode;
  hideOnMobile?: boolean;
};
export const PageHeader = ({
  title,
  actions,
  hideOnMobile = true
}: PageHeaderProps) => {
  const media = useMedia();
  if (hideOnMobile && !media.gtSm) {
    return null;
  }
  return <YStack paddingHorizontal="$5" paddingVertical={20} justifyContent="center" backgroundColor="$surface1" width="100%" data-sentry-element="YStack" data-sentry-component="PageHeader" data-sentry-source-file="PageHeader.web.tsx">
      <XStack justifyContent="space-between" alignItems={media.gtSm ? "flex-start" : "center"} data-sentry-element="XStack" data-sentry-source-file="PageHeader.web.tsx">
        <Headline1 color="$textDefault" size="$8" data-sentry-element="Headline1" data-sentry-source-file="PageHeader.web.tsx">
          {title}
        </Headline1>
        {actions ? <XStack gap="$3">{actions}</XStack> : null}
      </XStack>
    </YStack>;
};